import Box from '@components/Box';
import TextInputContainer from '@containers/TextInputContainer';
import WrapperDetails from './WrapperDetails';
import { Grid, Row } from '@components/Grid';
import { TProfileContactForm } from './../types';
import { updateProfileContact } from '@api/apiClient';
import { useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useProfile } from '@contexts/ProfileContext';
import { useTranslation } from 'react-i18next';

const ContactDetails: React.FC = (): React.ReactElement => {
  const { account, get } = useProfile();
  const { t } = useTranslation();

  const {
    error: errorUpdateProfileContact,
    isError: isErrorUpdateProfileContact,
    isLoading: isLoadingUpdateProfileContact,
    mutate: mutateUpdateProfileContact,
    reset: resetUpdateProfileContact
  } = useMutation({
    mutationFn: updateProfileContact,
    onSuccess: (_, variables) => {
      get();
      reset(variables);
    }
  });

  const { control, formState, handleSubmit, reset } = useForm<TProfileContactForm>({
    defaultValues: {
      chat: account?.chat ?? '',
      emailForNewsletter: account?.emailForNewsletter ?? '',
      name: account?.name ?? ''
    }
  });

  const submit = (form: TProfileContactForm) => {
    const data: TProfileContactForm = {
      chat: form.chat,
      emailForNewsletter: form.emailForNewsletter,
      name: form.name
    };
    mutateUpdateProfileContact(data);
  };

  return (
      <WrapperDetails
          btnAction={() => {
            handleSubmit(submit)();
            resetUpdateProfileContact();
          }}
          btnDisabled={!formState.isDirty}
          btnPending={isLoadingUpdateProfileContact}
          btnText={t('profileData.buttonSave')}
          error={errorUpdateProfileContact}
          isActionVisible
          isError={isErrorUpdateProfileContact}
          title={t('profileData.contactDetails')}
      >
        <Grid>
          <Row>
            <Box pb={5}>
              <TextInputContainer
                  control={control}
                  name="name"
                  rules={{ required: t('defaultFormErrors.required') }}
                  title={t('profileData.name')}
              />
            </Box>
          </Row>
          <Row>
            <Box pb={5}>
              <TextInputContainer
                  control={control}
                  name="emailForNewsletter"
                  title={t('profileData.emailForNewsletter')}
                  type="email"
              />
            </Box>
          </Row>
          <Row>
            <Box>
              <TextInputContainer
                  control={control}
                  name="chat"
                  rules={{ required: t('defaultFormErrors.required') }}
                  title={account?.region === 'TR' ? t('profileData.chatTr') : t('profileData.chatCn')}
              />
            </Box>
          </Row>
        </Grid>
      </WrapperDetails>
  );
};

export default ContactDetails;